import { computed, Injectable, signal, WritableSignal } from '@angular/core';

import { DepositTable, TablesPropertiesDto } from '@connect-services/client/sdk/api';

export enum ColumnType {
    BOOLEAN = 'BOOLEAN',
    DATE = 'DATE',
    FLOAT = 'FLOAT',
    GEOM = 'GEOM',
    NUMBER = 'NUMBER',
    STRING = 'STRING',
    TIMESTAMPTZ = 'TIMESTAMPTZ',
}

@Injectable({
    providedIn: 'root',
})
export class CreateDepositLayerService {
    public readonly allCreatedLayersCount = computed(
        () => this.newCreatedLayers().length + this.createdTables().length,
    );
    public readonly createdTables = computed(() => this.tables().filter((table: DepositTable) => !table.wasImported));
    public readonly newCreatedLayers: WritableSignal<TablesPropertiesDto[]> = signal([]);
    public readonly tables: WritableSignal<DepositTable[]> = signal<DepositTable[]>([]);
}
